export function isBitmapSourceNode(el) {
  return !!el?.closest?.('.flowchart-bitmap-source');
}

export function firstBoardNode(nodeList) {
  if (!nodeList) return null;
  for (let i = 0; i < nodeList.length; i += 1) {
    if (!isBitmapSourceNode(nodeList[i])) return nodeList[i];
  }
  return null;
}

export function findTaskElement(id) {
  if (id == null || typeof document === 'undefined') return null;
  const escaped = window.CSS?.escape ? window.CSS.escape(String(id)) : String(id);
  return firstBoardNode(document.querySelectorAll(`[data-task-id="${escaped}"]`));
}

export function queryBoardNode(selector) {
  if (typeof document === 'undefined' || !selector) return null;
  return firstBoardNode(document.querySelectorAll(selector));
}
